module.exports = __webpack_public_path__ + "img/outpost64_ua.6cb0eef4.webp";